import { useEffect, useState } from "react";
import { CustomTable } from "../../../componentes/table/CustomTable";
import PageAPI from "../../../componentes/pagination/Pagination-Page";

const T = {
    bg: "#F7F9FC",
    surface: "#FFFFFF",
    surfaceAlt: "#F1F5F9",
    border: "#E2E8F0",
    borderStrong: "#CBD5E1",
    text: "#0F172A",
    textMid: "#475569",
    muted: "#94A3B8",
    primary: "#2563EB",
    primaryLight: "#EFF6FF",
    secondary: "#64748B",
    green: "#16A34A",
    greenLight: "#F0FDF4",
    red: "#DC2626",
    redLight: "#FEF2F2",
    blue: "#0EA5E9",
    blueLight: "#F0F9FF",
    acum: "#EEF2FF",
    acumText: "#4338CA",
    total: "#F8FAFC",
};

export default function TabelaDespesas({
    filtros,
    service,
    setModo
}) {
    const [data, setData] = useState({
        content: [],
        page: {
            number: null,
            size: null,
            totalElements: null,
            totalPages: null
        }
    });
    const [loading, setLoading] = useState(false);
    const [filtro, setFiltro] = useState("");
    const [filtroDebounced, setFiltroDebounced] = useState(filtro);
    const [page, setPage] = useState({
        page: 0,
        size: 20,
        sortKey: "id",
        sortDirection: "desc"
    });

    useEffect(() => {
        const timeout = setTimeout(() => {
            setFiltroDebounced(filtro);
        }, 300);

        return () => clearTimeout(timeout);
    }, [filtro]);

    useEffect(() => {
        fetchData();
    }, [filtroDebounced, filtros, page]);

    const fetchData = () => {
        setLoading(true);
        service
            .listarDespesasPaginada(filtros, page, filtroDebounced)
            .then(res => {
                setData(res.data);
            })
            .finally(() => setLoading(false));
    };

    const columns = [
        {
            key: "contaContabilReduzido",
            label: "Con Cod.",
            center: true
        },
        {
            key: "contaContabilDescricao",
            label: "Conta Descrição."
        },
        {
            key: "centroCustoCodigo",
            label: "CC Cod.",
            center: true,
            filter: false
        },
        {
            key: "centroCustoDescricao",
            label: "CC Descrição."
        },
        {
            key: "historico",
            label: "Histórico"
        },
        {
            key: "filialNome",
            label: "Unidade",
        },
        {
            key: "responsavelNome",
            label: "Responsável",
            center: true
        },
        {
            key: "data",
            label: "Data",
            format: "date",
            center: true
        },
        {
            key: "valor",
            label: "Valor",
            format: "currency",
            className: "font-semibold",
            center: false
        }
    ];

    return (
     
           <div className="mt-3" style={{
             background: T.surface, borderRadius: 16, border: `1px solid ${T.border}`,
             boxShadow: "0 2px 12px rgba(15,23,42,.07)", display: "flex", flexDirection: "column",
             maxHeight: "100vh", fontFamily: FONT, overflow: "hidden",
           }}>
            <div style={{
                padding: "16px 20px 12px",
                background: T.surfaceAlt, borderRadius: "16px 16px 0 0",
                display: "flex", flexDirection: "column", gap: 12,
            }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div style={{
                            width: 32, height: 32, background: T.primary, borderRadius: 8,
                            display: "flex", alignItems: "center", justifyContent: "center",
                        }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round">
                                <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" />
                                <line x1="9" y1="21" x2="9" y2="9" />
                            </svg>
                        </div>
                        <div>
                            <div style={{ fontSize: 15, fontWeight: 700, color: T.text }}>Detalhamento BP</div>
                            <div style={{ fontSize: 11, color: T.muted }}>Base de Lançamentos Realizados</div>
                        </div>
                    </div>

                    <button onClick={() => setModo("BP")} style={{
                        display: "inline-flex", alignItems: "center", gap: 6,
                        padding: "7px 14px", borderRadius: 8, border: `1.5px solid ${T.border}`,
                        background: T.surface, color: T.textMid, fontSize: 12, fontWeight: 600,
                        cursor: "pointer", transition: "all .15s",
                    }}
                        onMouseEnter={e => e.currentTarget.style.borderColor = T.primary}
                        onMouseLeave={e => e.currentTarget.style.borderColor = T.border}
                    >
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                            <path d="M9 17H5a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v0a2 2 0 0 0-2-2h-4" />
                            <polyline points="12 3 12 15" /><polyline points="8 11 12 15 16 11" />
                        </svg>
                        Ver Detalhamento do BP
                    </button>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
                    <InputSearch
                        value={filtro}
                        onChange={(e) => setFiltro(e.target.value)}
                    />
                </div>
            </div>

            <CustomTable
                data={data.content}
                columns={columns}
                loading={loading}
                maxHeight={500}
                exportable
                className="text-xs"
                showHeader={false}
            />

            <div className="pb-3">
                <PageAPI
                    page={data.page.number}
                    size={data.page.size}
                    totalElements={data.page.totalElements}
                    totalPages={data.page.totalPages}
                    loading={loading}
                    onPageChange={(newPage) => setPage(prev => ({ ...prev, page: newPage }))}
                    onPageSizeChange={(newSize) => setPage(prev => ({ ...prev, size: newSize }))}
                />
            </div>
        </div>
    );
}

const FONT = "var(--font-sans)";

const InputSearch = ({ value, onChange }) => {
    return (
        <div style={{ position: "relative", minWidth: 250 }}>
            <svg
                style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}
                width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={T.muted} strokeWidth="2.2" strokeLinecap="round"
            >
                <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
                type="search"
                value={value}
                onChange={onChange}
                placeholder="Pesquisar por qualquer palavra..."
                style={{
                    width: "100%", paddingLeft: 32, paddingRight: 12, paddingTop: 7, paddingBottom: 7,
                    border: `1.5px solid ${T.border}`, borderRadius: 8, fontSize: 13,
                    fontFamily: FONT, color: T.text, background: T.surface,
                    outline: "none", transition: "border-color .15s, box-shadow .15s",
                }}
                onFocus={e => { e.target.style.borderColor = T.primary; e.target.style.boxShadow = `0 0 0 3px ${T.primary}18`; }}
                onBlur={e => { e.target.style.borderColor = T.border; e.target.style.boxShadow = "none"; }}
            />
        </div>
    );
};